// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sh_token');
    if (token) {
      api.me()
        .then(setUser)
        .catch(() => localStorage.removeItem('sh_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { token } = await api.login({ email, password });
    localStorage.setItem('sh_token', token);
    const me = await api.me();
    // Clear any locks from previous session/user
    localStorage.removeItem('sh_locks');
    setUser(me);
    return me;
  };

  const register = async (data) => {
    const { token } = await api.register({ ...data, role: 'SHOPPER' });
    localStorage.setItem('sh_token', token);
    const me = await api.me();
    localStorage.removeItem('sh_locks');
    setUser(me);
    return me;
  };

  const logout = () => {
    localStorage.removeItem('sh_token');
    localStorage.removeItem('sh_locks'); // clear lock state on logout
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
